import {
  DEFAULT_HORIZONTAL_GRADIENT_POSITION,
  DEFAULT_VERTICAL_GRADIENT_POSITION,
} from "@components/LGradient";
import MaskedView from "@react-native-masked-view/masked-view";
import { createText, TextProps } from "@shopify/restyle";
import { Theme } from "@theme";
import * as rudderstack from "@utils/rudderstack";
import { GestureResponderEvent, TextProps as RNTextProps } from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import { GradientPosition } from "types/gradient";
import type { ReactNode } from "react";

type RestyleProps = TextProps<Theme>;

export type Props = RestyleProps &
  RNTextProps & {
    gradientColours?: string[];
    gradientDirection?: "horizontal" | "vertical";
    gradientPosition?: GradientPosition;
    children: ReactNode;
    sentryEventName?: string;
  };

const LTextSimple = createText<Theme>();

export const TextComponent = ({
  gradientColours,
  gradientDirection = "horizontal",
  gradientPosition,
  onPress,
  sentryEventName,
  ...rest
}: Props) => {
  const onPressInternal = onPress
    ? (event: GestureResponderEvent) => {
        void rudderstack.track("press", { value: sentryEventName || "" });
        onPress(event);
      }
    : undefined;

  if (!gradientColours) {
    return (
      <LTextSimple
        {...(rest as any)}
        allowFontScaling={false}
        maxFontSizeMultiplier={1}
        onPress={onPressInternal}
      />
    );
  }

  const internalGradientPosition =
    gradientPosition === undefined
      ? gradientDirection === "horizontal"
        ? DEFAULT_HORIZONTAL_GRADIENT_POSITION
        : DEFAULT_VERTICAL_GRADIENT_POSITION
      : gradientPosition;

  return (
    <MaskedView
      maskElement={
        <LTextSimple
          {...(rest as any)}
          allowFontScaling={false}
          maxFontSizeMultiplier={1}
        />
      }
    >
      <LinearGradient
        colors={gradientColours as any}
        start={internalGradientPosition.start}
        end={internalGradientPosition.end}
      >
        <LTextSimple
          {...(rest as any)}
          allowFontScaling={false}
          maxFontSizeMultiplier={1}
          style={[rest.style, { opacity: 0 }]}
        />
      </LinearGradient>
    </MaskedView>
  );
};

const LText = createText<Theme, Props>(TextComponent);

export default LText;
